import { useContext, useMemo, useState } from "react";
import CmsPage from "../components/cms-page";
import CookieBanner from "../components/cookie-banner";
import EventBody from "../components/event/event-body";
import Footer from "../components/footer";
import Header from "../components/header";
import LanguageContext from "../context/language";
import UserContext from "../context/user";
import useAppLanguage from "../hooks/useAppLanguage";
import { translateSurvey } from "../utils/lang";
import AppsLogin from "./apps-login";
import CookiePolicy from "./cookie-policy";
import ForgotPassword from "./forgot-password";
import SurveyError from "./survey-error";
import { useQuery } from "@tanstack/react-query";
import useTealiumOnPageLoad from "../utils/tealium";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { useParams } from "react-router-dom";

const Event = () => {
  const { logged, callApi } = useContext(UserContext);
  const { language, defaultLabels, unloggedLanguage } = useContext(LanguageContext);
  const [error, setError] = useState();
  const [forgotPw, setForgotPw] = useState();
  const [navigation, setNavigation] = useState();
  const { id } = useParams();

  useTealiumOnPageLoad({ pageSection1: "event" });
  useDocumentTitle("EssilorLuxottica Event Booking");

  const { data: event, isFetching } = useQuery(["event", id], () => callApi(`/events/${id}`), {
    enabled: logged,
    onError: (error) => setError(error),
  });

  const { appLang, setAppLang, languages, labels } = useAppLanguage(
    defaultLabels,
    !isFetching && language,
    event,
    logged ? null : unloggedLanguage
  );

  const translatedEvent = useMemo(() => {
    if (event) {
      return translateSurvey(event, appLang);
    }
  }, [event, appLang]);

  return (
    <>
      {logged ? (
        isFetching || Object.entries(labels).length === 0 ? (
          <div className="loading-spinner mt" />
        ) : (
          <>
            <Header
              selectedLanguage={appLang}
              setSelectedLanguage={setAppLang}
              languages={languages}
              labels={labels}
            />
            <main className="survey-detail">
              {error ? (
                <SurveyError status={error?.status} labels={labels} />
              ) : navigation ? (
                {
                  "privacy-policy": (
                    <CmsPage
                      path="footer/privacy-policy"
                      title={labels?.WELFARE_PRIVACY_POLICY}
                      setNavigation={setNavigation}
                      key={navigation}
                      appLang={appLang}
                    />
                  ),
                  "cookie-policy": (
                    <CookiePolicy logged={true} setNavigation={setNavigation} appLang={appLang} />
                  ),
                }[navigation]
              ) : (
                <EventBody event={translatedEvent} labels={labels} appLang={appLang} />
              )}
            </main>
            <Footer setNavigation={setNavigation} labels={labels} />
          </>
        )
      ) : forgotPw ? (
        <ForgotPassword setForgotPw={setForgotPw} labels={labels} />
      ) : navigation === "cookie-policy" ? (
        <CookiePolicy logged={false} setNavigation={setNavigation} appLang={appLang} />
      ) : (
        <AppsLogin setForgotPw={setForgotPw} labels={labels} />
      )}
      <CookieBanner labels={labels} setNavigation={setNavigation} />
    </>
  );
};

export default Event;
